import { ValidatorErrorCode } from '@caterdesk/utils--gm-validation'

import { TFunction } from 'i18next'
import { match } from 'ts-pattern'

export const translateValidationErrors = (
  t: TFunction,
  errorCode: ValidatorErrorCode,
): string | null => {
  const translationKey = match(errorCode)
    .with('NO_PAYMENT_METHOD', () => 'pleaseSelectAPayment')
    .with('NO_BILLING_ADDRESS', () => 'pleaseEnterABilling')
    .with('NO_BILLING_ADDRESS_LABEL', () => 'pleaseEnterABilling1')
    .with('NO_BILLING_ADDRESS_STREET', () => 'pleaseEnterABilling2')
    .with('NO_BILLING_ADDRESS_POSTCODE', () => 'pleaseEnterABilling3')
    .with('NO_BILLING_ADDRESS_CITY', () => 'pleaseEnterABilling4')
    .with('NO_BILLING_ADDRESS_COUNTRY', () => 'pleaseEnterABilling5')

    .with('INVALID_ADDRESS', () => 'invalidAddress')
    .with('INVALID_DATE', () => 'enterAValidDate')
    .with('NO_DATE', () => 'enterAValidTime')
    .with('INVALID_TIME', () => 'enterAValidTime')
    .with('DATE_PAST', () => 'thisDateIsntAvailable')
    .otherwise(() => null)
  if (!translationKey) return null
  const translation = t(`marketplace:${translationKey}`)
  return translation !== translationKey ? translation : null
}
